import { useNavigate } from "react-router-dom";
import { useAuth } from "../Context/AuthContext";
import { serverLogout } from "./serverLogout";

export function Logout() {
  const auth = useAuth();
  const navigate = useNavigate();
  serverLogout().finally(() => {
    window.sessionStorage.clear();
    auth.logout();
    localStorage.clear("registration_product");
    navigate("/login", { replace: true });
  });
}
